export const environment = {
  production: false,
  apiURL: 'https://apistest.tracsa.com.mx/api/v1/',
  site: 'https://tracsatest.tracsa.com.mx/',
  commercialBusinessList: [
    ['CI', 'CONTROL INTERNO CONTABILIDAD'],
    ['CS', 'SERVICIOS COMERCIALES'],
    ['EQ', 'SERVICIOS DE EQUIPO'],
    ['FY', 'FORESTAL'],
    ['GC', 'CONTRATISTA LOCAL'],
    ['HC', 'CONTRATISTA GRANDE'],
    ['IM', 'INDUSTRIAL'],
    ['MA', 'MARINOS'],
    ['MN', 'MINERIA'],
    ['PC', 'PAVIMENTACION'],
    ['PE', 'PETROLEO Y GAS'],
    ['PS', 'GOBIERNO (SERVICIOS PUBLICOS)'],
    ['QA', 'CANTERA Y AGREGADOS'],
    ['SN', 'CONCRETOS'],
    ['ST', 'SERVICIOS DE TRANSPORTE'],
    ['WA', 'DESPERDICIOS'],
  ],
  getToken: 'https://apisalesforce-link-test.tracsa.com.mx/api/v1/get-sf-token?env=devcap',
  token: '$2y$10$N.kDlb1aMMZv1DbnAgcOv.S4dORvHx1kla3eg9wE3OR90YeoCk0Pm',
  lead: 'https://tracsa--devcap.sandbox.my.salesforce.com/services/data/v58.0/sobjects/Lead',
  case: 'https://tracsa--devcap.sandbox.my.salesforce.com/services/data/v58.0/sobjects/Case',
  rtLead: '0124W000001AiFBQA0',
  rtCase: '0124W000001Ahc7QAC',
  apiSearch: 'https://apistest.tracsa.com.mx/search/'
};